import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { AppBar, Toolbar } from '@mui/material';
import celfinetLogo from '../../../../assets/Cyient_White_Std_RGB-01.png';

const useStyles = makeStyles(() => ({
	root: {
		boxShadow: 'none',
	},
}));

const Topbar = (props) => {
	const { className, ...rest } = props;

	const classes = useStyles();

	return (
		<AppBar
			{...rest}
			className={clsx(classes.root, className)}
			color="primary"
		>
			<Toolbar>
				<RouterLink to="/">
					<img alt="Logo" src={celfinetLogo} style={{ maxHeight: '55px', borderRadius: '0%' }} />
				</RouterLink>
			</Toolbar>
		</AppBar>
	);
};

Topbar.propTypes = {
	className: PropTypes.string,
};

export default Topbar;
